import {
  type CampaignQueryParam,
  CampaignQueryParamName,
} from "src/campaigns/objects/CampaignQueryParam";
import {
  type DispatchStatusQueryParam,
  DispatchStatusQueryParamName,
} from "src/dispatches/objects/DispatchStatusQueryParam";
import {
  GetPathWithParams,
  type QueryParams,
} from "src/utilities/URLParamsUtils";

export const DISPATCHES_VIEW_PATH: string = "/dp";

/**
 * @deprecated
 */
export function GetDispatchesViewPath(
  dispatchStatus?: DispatchStatusQueryParam,
  campaign?: CampaignQueryParam,
): string {
  const queryParams: QueryParams = {};

  // Get Dispatch Status.
  if (dispatchStatus) {
    queryParams[DispatchStatusQueryParamName] = dispatchStatus;
  }

  if (campaign) {
    if (typeof campaign === "string") {
      queryParams[CampaignQueryParamName] = campaign;
    } else {
      queryParams[CampaignQueryParamName] = campaign.campaignUUID;
    }
  }

  return GetPathWithParams(DISPATCHES_VIEW_PATH, queryParams);
}

export const DISPATCH_DETAIL_VIEW_PATH = "/dp/:dispatchUUID";

/**
 * @deprecated
 */
export function GetDispatchDetailViewPath(
  dispatchUuid: string,
  dispatchStatus?: DispatchStatusQueryParam,
  campaign?: CampaignQueryParam,
): string {
  const url = DISPATCH_DETAIL_VIEW_PATH.replace(":dispatchUUID", dispatchUuid);

  // Add Query Params
  const queryParams: QueryParams = {};

  if (dispatchStatus) {
    queryParams[DispatchStatusQueryParamName] = dispatchStatus;
  }

  if (campaign) {
    if (typeof campaign === "string") {
      queryParams[CampaignQueryParamName] = campaign;
    } else {
      queryParams[CampaignQueryParamName] = campaign.campaignUUID;
    }
  }

  return GetPathWithParams(url, queryParams);
}

export const DISPATCH_CREATE_VIEW_PATH = "/dp/create";

/**
 * @deprecated
 */
export function GetCreateDispatchViewPath(
  dispatchStatus?: DispatchStatusQueryParam,
  campaign?: CampaignQueryParam,
): string {
  const queryParams: QueryParams = {};

  // Get Dispatch Status.
  if (dispatchStatus) {
    queryParams[DispatchStatusQueryParamName] = dispatchStatus;
  }

  if (campaign) {
    if (typeof campaign === "string") {
      queryParams[CampaignQueryParamName] = campaign;
    } else {
      queryParams[CampaignQueryParamName] = campaign.campaignUUID;
    }
  }

  return GetPathWithParams(DISPATCH_CREATE_VIEW_PATH, queryParams);
}

export const DISPATCH_EDIT_VIEW_PATH = "/dp/:dispatchUUID/edit";

export const DISPATCH_COPY_VIEW_PATH = "/dp/:dispatchUUID/copy";
